import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { memoGeneric } from '@/js/libs/memo';
import { LabelWrapper, Tag, Value } from './styled';
export const SelectedLabel = memoGeneric(function SelectedLabel({ selected, label, formatOptionLabel }) {
    const selectedLabel = useMemo(() => (formatOptionLabel && selected[0] ? formatOptionLabel(selected[0]) : selected[0]?.label), [formatOptionLabel, selected]);
    return (_jsxs(LabelWrapper, { children: [label && (_jsxs("span", { children: [label, ':'] })), _jsx(Value, { "data-testid": 'dropdown-value', children: selectedLabel }), selected.length - 1 > 0 && _jsx(Tag, { "data-testid": 'tag-length', children: `+${selected.length - 1}` })] }));
});
